import { useNavigate } from 'react-router-dom'

import heroGraphic from '../../assets/img-hero2x.png'
// import heroBgShape from '../../assets/'
import { FeatureCheckmark } from '../../assets/FeatureCheckmark'
import { ReactComponent as CtaArrowIcon } from '../../assets/cta-arrow.svg'

const Hero = () => {
    const navigate = useNavigate()

    const HERO_BULLETS = [
        'Track every deal from acquisition to sale',
        'Underwrite and score every deal quickly',
        'Deal scoring & projections',
        'Analyze rent trends and comps',
    ]

    const HeroChecklist = ({ items }) => {
        return (
            <div className="flex flex-col gap-3 mt-6">
            {items.map((item) => (
                <div key={item} className="flex items-center gap-4">
                {/* <img src={check} alt="check" className="w-[28px] h-[28px]" /> */}
                <FeatureCheckmark/>

                <span className="text-[18px] text-brand-dark font-medium">
                    {item}
                </span>
                </div>
            ))}
            </div>
        )
    }

  return (
    <section className="relative overflow-hidden bg-brand-pageFill min-h-[760px]">
      {/* <img
        src={heroBgShape}
        alt="bg shape"
        className="absolute left-0 bottom-0 w-[520px] opacity-40 pointer-events-none"
      /> */}

      <div className="max-w-canvas mx-auto pt-[120px] pb-[80px] flex items-center justify-between gap-12 relative z-10">
        <div className="w-[620px] shrink-0">
          <h1 className="text-[56px] leading-[1.05] font-black tracking-[-3px] text-brand-dark">
            Analyze Deals with{' '}
            <span className="text-brand-green">Clarity &amp; Confidence</span>
          </h1>

          <p className="mt-6 text-[22px] leading-[1.6] text-black/75 max-w-[620px]">
            Analyze, compare, and present deals—all in one place.
          </p>

          <HeroChecklist items={HERO_BULLETS} />

          <button
            onClick={() => navigate('/signup')}
            className="flex items-center gap-2 mt-12 h-[56px] px-10 rounded-full bg-brand-green text-white text-[16px] font-semibold shadow-soft"
          >
            Start 7-Day Free Trial
            <CtaArrowIcon/>
          </button>
        </div>

        <div className="flex-1 flex justify-end">
          <img
            src={heroGraphic}
            alt="hero"
            className="w-[650px] max-w-none"
          />
        </div>
      </div>
    </section>
  )
}

export default Hero